import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-139">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between" style={{
      height: '90px',
      paddingTop: '8px',
      paddingBottom: '8px'
    }} data-id="element-140">
        <div className="flex items-center" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/t2kwCs67Yc7emwGGMrjmR2/Marca_con_fondo_transparente-removebg-preview.png" alt="El Código del Bienestar" style={{
          width: '200px',
          height: 'auto',
          maxHeight: '100%',
          objectFit: 'contain',
          backgroundColor: 'transparent'
        }} className="block border-0 outline-none bg-transparent" data-id="element-142" />
        </div>
        <a href="#pricing" className="bg-primary text-white px-6 py-2.5 rounded-full font-medium hover:bg-primary/90 transition-colors shadow-sm hover:shadow-md" data-id="element-143">
          Quiero dormir mejor &rarr;
        </a>
      </div>
    </nav>;
}